import { BaseModelDto } from '../../base'
import { Field, Int, ObjectType } from '@nestjs/graphql'
import { BaseThreadUserDto } from '../thread/baseThreadUser.dto'

@ObjectType()
export class MessagePostDto extends BaseModelDto {
  // New, Read
  @Field(t => Int)
  state!: number

  @Field()
  stateDate!: Date

  @Field()
  message!: string

  @Field(t => Int)
  threadId!: number

  // This will either originate from an ArcTeam, PenName or User but we don't care from the post
  // as we just want the information about the name and image associated with the post.
  @Field(t => BaseThreadUserDto)
  sender!: BaseThreadUserDto
}
